import { api } from 'utils/axios';
import { API_BASE_URL } from 'utils/constants';

export const clearCDNCacheApiCall = (slug) => {
  const smkPrefix = process.env.REACT_APP_SCHOOLMYKIDS_WEB_URL;

  const urls = [`${smkPrefix}/worksheet/${slug}`, `${smkPrefix}/worksheets`];
  api({
    method: 'POST',
    url: `${API_BASE_URL}/admin-tools/clearCDNCache`,
    data: {
      urls,
    },
  });
};
